import { Form, Formik } from 'formik';
import React from 'react';

import AutoSave from '@components/AutoSave';
import SwitchField from '@components/Form/SwitchField';
import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import Spinner from '@components/Spinner';
import { usePrivacySettings, usePrivacySettingsUpdate } from '@hooks';
import { Theme } from '@interfaces/global';

import schema from './schema';
import styles from './styles.module.scss';

const Privacy = () => {
  const { privacySettings, isLoadingPrivacySettings } = usePrivacySettings();
  const { mutate: updatePrivacySettings, showSave } = usePrivacySettingsUpdate();

  const handleSubmit = ({ ccpaDoNotSellPersonalInfo }) => {
    const sanitizedParams = {
      user: {
        ccpa_do_not_sell_personal_info: ccpaDoNotSellPersonalInfo,
      },
    };
    updatePrivacySettings(sanitizedParams);
  };

  if (isLoadingPrivacySettings) return <Spinner />;

  return (
    <div>
      <SectionBreakTitle
        className="mb-32"
        titleClassName="text-primary-magenta"
        color={SectionColor.Magenta}
        title="Privacy rights"
      />
      <Formik
        onSubmit={handleSubmit}
        initialValues={{
          ccpaDoNotSellPersonalInfo: privacySettings.ccpaDoNotSellPersonalInfo,
        }}
        validationSchema={schema}
      >
        {() => (
          <Form>
            <AutoSave debounceMs={500} />
            <div className="relative">
              <SwitchField
                colorTheme={Theme.Light}
                label="Do Not “Sell” My Personal Information"
                name="ccpaDoNotSellPersonalInfo"
              />
              <p className="font-suisse-intl text-body-sm text-black">
                We never exchange your personal information for money. We do provide your
                information to outside services such as social networks so that they can tailor your
                content for your interest in The Information.
              </p>
              <div className={styles.saveContainer}>{showSave && <span>Saved</span>}</div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Privacy;
